import { useMutation } from '@tanstack/react-query'
import { deletePaymentLimit } from 'services/PaymentLimitsService'

export const useDeletePaymentLimitMutation = () => {
  return useMutation({ mutationFn: deletePaymentLimit })
}
